import React, { useContext } from 'react';

import { 
    Typography,
} from '@material-ui/core';

import { CustomerRequestContext } from '../CustomerRequestContext';

import { makeStyles } from '@material-ui/styles';
const useStyles = makeStyles((theme) => ({
    root: {        
    }
}));

export const RequestHeader = (props) => {
    const classes = useStyles(); 

    const {
        state
    } = useContext(CustomerRequestContext);

    const {
        request
    } = state;

    return (
        <div className={classes.root}>
            <Typography component="h2" gutterBottom variant="overline">
                {request.customerRequestId !== 0 ? `#NUMBER ${request.customerRequestId} ${request.sapCode ? ` - #SAP ${request.sapCode}` : ""}` : "DRAFT"}
            </Typography>
            <Typography variant="h4">
                {request.customerName  || "New Request"}
            </Typography>
        </div>
    );
}
